import { render, staticRenderFns } from "./MonitorUnitItem.vue?vue&type=template&id=4857f36a"
import script from "./MonitorUnitItem.vue?vue&type=script&lang=js"
export * from "./MonitorUnitItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports